








































import { ButtonType } from '../../../../AppButtonNew/defaultConfigs';
import StartPageSlider from '../../parts/slider/StartPageSlider.vue';
import AppPicture from '@/uikit/components/AppPicture/AppPicture.vue';
import AppSvgIcon from '@/uikit/components/AppSvgIcon/AppSvgIcon.vue';
import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';

export default {
  name: 'Events',
  components: {
    AppButtonNew,
    AppSvgIcon,
    AppPicture,
    StartPageSlider,
  },
  props: {
    cfg: {
      type: Object as () => LayoutConfig['content']['startPage']['sections']['events'],
      required: true,
    },
    data: {
      type: Array as () => LayoutDataSet['events'],
    },
  },
  mounted() {},
  computed: {
    getButtonType() {
      return ButtonType;
    },
    getProgramsLength() {
      return (
        this.$store.state.defaultLayout.dataSet.navSidebar.find(
          (el: any) => el.name === 'programs'
        )?.count || 0
      );
    },
  },
  methods: {
    getTextPostfix(
      value: number,
      substr: string,
      rightSubtract: Array<string>
    ) {
      if (value % 10 === 0) return substr + rightSubtract[2];
      if (value % 10 === 1) return substr + rightSubtract[0];
      if (value % 10 < 5) return substr + rightSubtract[1];
      return substr + rightSubtract[2];
    },
    getText(value: number, substr: string, rightSubtract: Array<string>) {
      const result =
        value > 10 && value < 20
          ? substr + rightSubtract[2]
          : this.getTextPostfix(value, substr, rightSubtract);
      return String(value) + ' ' + result;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/events/Events.vue